import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';

interface PPTModalProps {
  isOpen: boolean;
  onClose?: () => void;
}

const PPTModal: FC<PPTModalProps> = ({ isOpen = false, onClose }) => {
  const { t } = useTranslation('planAction');

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth>
      <DialogTitle textAlign="center">{t('PPTGenerate')}</DialogTitle>
      <DialogContent>
        <Stack
          direction="row"
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            pt: 6,
            pb: 1,
          }}
        >
          <CircularProgress />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PPTModal;
